// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/weui.css'
import axios from 'axios'
import AppSetting from './AppSetting'

import store from "./store";
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

/*const store = new Vuex.Store({
  state: {
    polyvsocket: null,
  },
  mutations: {
    set(state, socket) {
      state.polyvsocket = socket;
    },
  }
});*/

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);


import '@/plugin/extendFn'
// import './assets/style/style.css'
import './assets/style/common.css'
import extendFn from "./plugin/extendFn"
import waiting from "./plugin/waiting";
import waitingplugin from "@/plugin/waiting/index.js";

Vue.use(waitingplugin);
// import store from "./store";
Vue.component("waiting", waiting);
// import mui from 'mui'
Vue.prototype.GLOBAL = {
  SOCKETPORT:AppSetting.getSocketPort()
}


import vueSwiper from 'vue-awesome-swiper'

Vue.use(vueSwiper);


import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)
// Vue.prototype.emoji = emoji
Vue.use(extendFn);
import mVueUtils from "./plugin/mVueUtils"

Vue.use(mVueUtils);
Vue.config.productionTip = false

//设置时间方法
Date.prototype.Format = function (fmt) { //
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};

let head = document.getElementsByTagName('head')[0];
let link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';


// head.appendChild(link);


let sUserAgent = navigator.userAgent.toLowerCase();
if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
  //跳转移动端页面
//rem字体
  let origin
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }
  origin = window.location.origin;
  console.log(origin)
  let pathname = window.location.pathname;
  let search = window.location.search;
  console.log('0000----', search)
  window.location.href = window.location.href.replace('cmdhra_pc', 'cmdhra_tpl');
  // if (search.indexOf('?type') != -1) {//说明是详情页面
  //   window.location.href = window.location.href.replace('cmdhra_pc', 'cmdhra_tpl');
  // } else {
  //   let back = `${origin}/cmdhra_tpl/index`;
  //   window.location.href = back;
  // }
}

document.body.addEventListener('focusout', () => {
  setTimeout(() => {
    const scrollHeight =
      document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0))
  }, 50)
})

const vue= new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default{
  vue
}


// WEBPACK FOOTER //
// ./src/main.js